
<div class="app-content content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
        <div class="content-header row">
        </div>
        <div class="content-body">
            <!-- users list start -->
            <section class="app-user-list">
                <!-- users filter start -->
                <div class="card">
                    <h5 class="card-header">Filtros de búsqueda</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <input class="form-control form-control-sm" type="text" placeholder="Nombre parámetro"
                                       [(ngModel)]="nombreBuscar" (change)="obtenerListaParametros()">
                            </div>
                            <div class="col-md-4">
                                <select class="select2 form-control form-control-sm" [(ngModel)]="tiposOpciones"
                                        (change)="obtenerListaParametros()">
                                    <option value="" selected>- Tipo de parámetro -</option>
                                    <option *ngFor="let tipo of tipos" value="{{tipo.valor}}">{{tipo.valor}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- users filter end -->
                <!-- list section start -->
                <div class="card">

                    <div class="row m-75">
                        <div class="col-lg-12 col-xl-6">
                            <label>Mostrar</label>
                            <select class="form-control-sm" [(ngModel)]="pageSize" (change)="obtenerListaParametros()">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>

                        </div>
                        <div class="col-lg-12 col-xl-6 text-right">
                            <button class="btn btn-success" tabindex="0" (click)="exportar()"
                                    type="button">
                                Exportar a Excel
                            </button>
                            <button *ngIf="currentUserValue.acciones.GDE.CREAR"
                                    class="btn btn-primary" tabindex="0" aria-controls="DataTables_Table_0"
                                    type="button" data-toggle="modal" data-target="#modals-slide-in"
                                    (click)="insertarParametro()">
                                Añadir parámetro
                            </button>
                        </div>
                    </div>
                    <div class="card-datatable table-responsive pt-0">
                        <table class="user-list-table table">
                            <thead class="thead-light">
                            <tr>
                                <th>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck2"/>
                                        <label class="custom-control-label" for="customCheck2"></label>
                                    </div>
                                </th>
                                <th>Parámetro</th>
                                <th>Tipo</th>
                                <th>Descripción</th>
                                <th>Valor</th>
                                <th>Minimo</th>
                                <th>Máximo</th>
                                <th>Tipo de dato</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let parametro of parametros">
                                <td>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck2"/>
                                        <label class="custom-control-label" for="customCheck2"></label>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex justify-content-left align-items-center">
                                        <div class="d-flex flex-column">
                                            <a class="user-name text-truncate mb-0">
                                                <span class="font-weight-bold">{{parametro.nombre}}</span></a>
                                        </div>
                                    </div>
                                </td>
                                <td> {{parametro.tipo}} </td>
                                <td> {{parametro.descripcion}}</td>
                                <td> {{parametro.valor}}</td>
                                <td> {{parametro.maximo}}</td>
                                <td> {{parametro.minimo}}</td>
                                <td> {{parametro.tipoVariable}}</td>
                                <td>
                                    <a *ngIf="currentUserValue.acciones.GDE.ESCRIBIR"
                                       data-toggle="modal" data-target="#modals-slide-in"
                                       (click)="editarParametro(parametro.id, parametro.nombre,parametro.idTipo,parametro.desccripcion)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                             stroke-linecap="round" stroke-linejoin="round" class="mr-50">
                                            <polyline points="21 8 21 21 3 21 3 8"></polyline>
                                            <rect x="1" y="3" width="22" height="5"></rect>
                                            <line x1="10" y1="12" x2="14" y2="12"></line>
                                        </svg>
                                    </a>
                                    <a *ngIf="currentUserValue.acciones.GDE.BORRAR"
                                       (click)="abrirModal(contenido,parametro.id)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                             stroke-linecap="round" stroke-linejoin="round" class="mr-50">
                                            <polyline points="3 6 5 6 21 6"></polyline>
                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                            <line x1="10" y1="11" x2="10" y2="17"></line>
                                            <line x1="14" y1="11" x2="14" y2="17"></line>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                    <ngb-pagination #paginator [collectionSize]="collectionSize" [(page)]="page" [(pageSize)]="pageSize"
                                    [maxSize]="5" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>

                </div>
                <!-- list section end -->
                <ng-template #contenido let-modal>
                    <div class="modal-header">
                        <h4 class="modal-title">Mensaje</h4>
                        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss( 'Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Confirma eliminar</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" (click)="cerrarModal()">SI</button>
                    </div>
                </ng-template>
                <!-- Modal to add new user starts-->
                <div class="modal modal-slide-in new-user-modal fade" id="modals-slide-in">
                    <div class="modal-dialog">
                        <div class="modal-content pt-0">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">×</button>
                            <div class="modal-header mb-1">
                                <h5 class="modal-title" id="exampleModalLabel">Nuevo parámetro</h5>
                            </div>
                            <div class="modal-body flex-grow-1">
                                <form class="auth-login-form mt-2" [formGroup]="paramForm">
                                    <div class="form-group">
                                        <label class="form-label" for="basic-icon-default-fullname">Nombre
                                            parámetro:</label>
                                        <input type="text" class="form-control dt-full-name"
                                               id="basic-icon-default-fullname" name="nombre" formControlName="nombre"
                                               [(ngModel)]="nombre"/>
                                        <div *ngIf="submitted && f.nombre.errors" class="invalid-feedback"
                                             style="display: block;">
                                            <div *ngIf="f.nombre.errors.required">Nombre del parámetro es requerido
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="basic-icon-default-uname">Tipo de
                                            parámetro:</label>
                                        <input type="text" class="form-control dt-full-name"
                                               id="basic-icon-default-fullname" name="nombreTipo"
                                               formControlName="nombreTipo" [(ngModel)]="nombreTipo"/>
                                        <div *ngIf="submitted && f.nombreTipo.errors" class="invalid-feedback"
                                             style="display: block;">
                                            <div *ngIf="f.nombreTipo.errors.required">Tipo del parámetro es requerido
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="basic-icon-default-email">Descripción:</label>
                                        <input type="text" id="basic-icon-default-email" class="form-control dt-email"
                                               name="descripcion" formControlName="descripcion"
                                               [(ngModel)]="descripcion"/>
                                        <div *ngIf="submitted && f.descripcion.errors" class="invalid-feedback"
                                             style="display: block;">
                                            <div *ngIf="f.descripcion.errors.required">Descripción del parámetro es
                                                requerida
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="basic-icon-default-email">Tipo de
                                            variable:</label>
                                        <select class="select2 form-control form-control-sm" name="tipoVariable"
                                                formControlName="tipoVariable" [(ngModel)]="tipoVariable">
                                            <option value="" selected>- Tipo de parámetro -</option>
                                            <option value="entero">Entero</option>
                                            <option value="texto">Texto</option>
                                            <option value="booleano">Booleano</option>
                                            <option value="fecha">Fecha</option>
                                        </select>
                                        <div *ngIf="submitted && f.tipoVariable.errors" class="invalid-feedback"
                                             style="display: block;">
                                            <div *ngIf="f.tipoVariable.errors.required">Selección del tipo de variable
                                                es requerida
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="basic-icon-default-email">Máximo:</label>
                                        <input type="text" id="basic-icon-default-email" class="form-control dt-email"
                                               name="maximo" [(ngModel)]="maximo"
                                               [ngModelOptions]="{standalone: true}"/>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="basic-icon-default-email">Mínimo:</label>
                                        <input type="text" id="basic-icon-default-email" class="form-control dt-email"
                                               name="minimo" [(ngModel)]="minimo"
                                               [ngModelOptions]="{standalone: true}"/>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" for="basic-icon-default-email">Valor:</label>
                                        <input type="text" id="basic-icon-default-email" class="form-control dt-email"
                                               name="valor" formControlName="valor" [(ngModel)]="valor"/>
                                        <div *ngIf="submitted && f.valor.errors" class="invalid-feedback"
                                             style="display: block;">
                                            <div *ngIf="f.valor.errors.required">Valor es requerido</div>
                                        </div>
                                    </div>
                                </form>
                                <div class="form-group">
                                    <label class="form-label" for="">Padre:</label>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="basic-icon-default-email">Tipo Padre:</label>
                                    <select class="select2 form-control form-control-sm" name="tipoPadre"
                                            [(ngModel)]="tipoPadre" (change)="buscarPadre()"
                                            [ngModelOptions]="{standalone: true}">
                                        <option value="" selected>- Tipo de parámetro -</option>
                                        <option *ngFor="let tipo of tipos"
                                                value="{{tipo.valor}}">{{tipo.valor}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="basic-icon-default-email">Padre:</label>
                                    <select class="select2 form-control form-control-sm" name="idPadre"
                                            [(ngModel)]="idPadre">
                                        <option value="0" selected>- Padre -</option>
                                        <option *ngFor="let padre of padres"
                                                [ngValue]="padre.id">{{padre.valor}}</option>
                                    </select>
                                </div>
                                <button class="btn btn-primary mr-1" aria-label="Close" (click)="gestionarParametro()">
                                    Guardar
                                </button>
                                <button #dismissModal data-toggle="modal" data-target="#exito" data-dismiss="modal"
                                        style="display: none;"></button>
                                <button type="reset" class="btn btn-outline-secondary" data-dismiss="modal">Cancelar
                                </button>

                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal to add new user Ends-->
            </section>
            <!-- users list ends -->
        </div>
    </div>
</div>


